<template>
    <div class="wrapper-body flex-1">
        <ListCorrespondences :nodeId="nodeId" />
    </div>
</template>

<script>
    import ListCorrespondences from '@/components/ListCorrespondences.vue';

	export default {
		name: 'SentView',
        components: { ListCorrespondences },
        data () 
        {
            return {
                nodeId: 0,
            }
        },
        mounted () 
        {
            this.nodeId = 6
        },
	}
</script>